import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { deepClone } from '@tenant/utility/helper/Utils';
import { getListPipelinesQuery } from '../apis';
import { setFieldPipeline } from '..';
import queryKeys from '../constants/queryKeys';

// GET /api/pipelines -> List<PipelineGroupDto> (AC-2). No query params exist on the
// shipped endpoint, so this is always a full-list fetch; the list page filters client-side
// (OQ-6 default).
const useGetListPipelines = () => {
  const dispatch = useDispatch();

  const query = useQuery({
    queryKey: queryKeys.getList(),
    queryFn: getListPipelinesQuery,
  });

  useEffect(() => {
    const data = query?.data?.data;
    if (data) {
      dispatch(setFieldPipeline({ field: 'list', value: deepClone(data) }));
    }
  }, [query?.data, dispatch]);

  return query;
};

export default useGetListPipelines;
